
import React, { useEffect, useState } from "react";
import { Products } from "./Products";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { setSelected } from "../store/reducers/CartReducer";
import { Footer } from "./Footer";

export const ProductsPage = ({lang}) => {

  const [index,setIndex] = useState(0)

  //const categories =useSelector((state) => state.cart.products);
  const [products,setProducts] = useState([])
  const [animation,setAnimation] = useState(true)

  const [loading,setLoading] = useState(false)

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:1}))
}, []);

  const [filter,setFilter] = useState([])



  const [categories, setCategories] = useState([]);

  useEffect(() => {
   
  fetchCategories();
     
     }, []);
 
     const fetchCategories = async () => {
  
      setLoading(true)
      
 try {
  axios.get(`https://alhubaishi.future-swift.com/Api/Categories.php?id=1`)
  .then(res => {
    if(res.data.success === true){

  
        setCategories(res.data.categories);
        setLoading(false)
        fetchProducts(res.data.categories[0].code)
   
       

    }else{
      
      setLoading(false)
      toast.error(`${res.data.msg}`,{duration: 1000,},)
    
         
        }  
  

  })
} catch (error) { 


throw error;}      


     }

      


     const fetchProducts = async (code) => {

      setAnimation(true)
      
        try {
         axios.get(`https://alhubaishi.future-swift.com/Api/Products.php?code=${code}`)
         .then(res => {
           if(res.data.success === true){
       
            
           
             setProducts(res.data.products);
             setAnimation(false);
          
            
              
           }else{
             
       setProducts([])
       setAnimation(false);
            // toast.error(`${res.data.msg}`,{duration: 1000,},)
           
                
               }  
         
       
         })
       } catch (error) { 
       
       
       throw error;}      
       
       
            }
       



   

  const MenuList = ({ list , code , value , level , selected ,setFilter, fetchProducts }) => { 
    const [Index, setIndex] = useState(-1);
            return (
                <div className={`  `} >
             

               { list.length > 0 ?<div className="w-full flex gap-2  pt-[20px]">
                <h2  style={{fontFamily:'CairoMedium',placeContent:'center'}} className= {`${lang === 'en' ? "text-left" : "text-right"} w-[20%] text-[13px]  lg:text-[30px]  md:text-[20px]  sm:text-[15px]  xs:text-[13px] `} >
                {value}
                </h2>
                <div style={{overflowX:'auto'}}  className="flex gap-1 w-[80%] ">
                <button
              style={{fontFamily:'cairoLight'}}
                onClick={()=>{

                    
                    if(  code !== selected){
                        fetchProducts(code)
                    }
                 
                    const arr = filter.filter((v,i)=> i <= level )

            

                    arr[level].selected = code;
           
                setFilter(arr)
           
           }}
                className={` transition-all  duration-500  px-1 py-1  rounded-xl min-w-[80px] max-w-[80px]  ${
                  code === selected
                    ? "text-white drop-shadow-lg bg-primary min-w-[120px] max-w-[120px]   "
                    : "bg-zinc-100   " 
                } h-[35px] `}
              >
            {lang === 'en' ? 'All' : 'الكل' } 
              </button>

                {list.map((listItem, index) => (
                  
                  <MenuItem key={index} code={selected} fetchProducts={fetchProducts} item={listItem} setFilter={setFilter}  level={level} selectedIndex={Index}  setIndex={setIndex} />
                ))}
              
              </div> 
              </div>:''}

              </div>
            );
          }
          
    
    
    
    
          const MenuItem = ({ item , level , code , setFilter ,fetchProducts}) => {
    
        
            return (
              <>
             


           <button
                key={item.code}
                style={{fontFamily:'cairoLight'}}
                onClick={()=>{

                    if( Number(item.code) !==  Number(code)){
                        fetchProducts(item.code)
                    }
              
            if(filter.length-1 === level ){
              

                    const arr = filter;

                    arr[level].selected = item.code;



                setFilter([...arr , {code: item.code, value:item.value ,children:item.children, selected:item.code } ])
        

            }else if(filter.length-1 >= level ){
                const arr = filter.filter((v,i)=> i <= level )

            

                    arr[level].selected = item.code;
           
                setFilter([...arr ,  {code: item.code, value:item.value ,children:item.children, selected:item.code }])
             
                
            }
             
           }}
                className={`transition-all  duration-500  px-1 py-1  rounded-xl min-w-[80px]   ${
                 Number(item.code) ===  Number(code)
                    ? "text-white drop-shadow-lg bg-primary   "
                    : "bg-zinc-100   " 
                } h-[35px] `}
              >
            {lang === 'en' ? item.value_en : item.value }
              </button>
          
              </>
           
            );
          }
          
    
    
    
    
    
    




  return (
    <section  className=" py-[80px] px-[3%] text-right bg-white min-h-screen w-full">
     { loading ?


      <div  style={{overflowX:'hidden'}} className="m-auto max-w-[90%] flex gap-2 p-1">
{[...Array(10)].map((_, index) => (


<div
                key={index}
                style={{fontFamily:'cairoLight'}}
              
                className={`flex items-center  px-1 py-1  rounded-xl min-w-[140px]
                
                   bg-zinc-100   
                 h-[50px]  animate-pulse`}
              >
              <div  className="  m-auto w-[80%]    h-2 rounded bg-gray-200 " />
              </div>
          


))}
</div>  

     :
      <div style={{overflowX:'auto'}} className="flex w-full gap-2 p-1 ">
            {categories.map((category, i) => (
              <button
                key={i}
                onClick={()=>{
            
            if(i!==index){
             setIndex(i)
           //  setFilter([{code: categories[i].code, value:categories[i].value ,children:categories[i].children}])
           setFilter([{code:category.code, value: lang === 'en' ? categories[i].value_en : categories[i].value  , selected:category.code ,children:categories[i].children}])
            
            fetchProducts(category.code)
            
            }
            
          //  console.log(JSON.stringify(category.products))
           }}
                className={`m-auto transition-all  duration-500  px-1 py-1  rounded-xl min-w-[140px] max-w-[140px]  ${
                  index === i
                    ? "text-white drop-shadow-lg bg-primary min-w-[140px] max-w-[140px]   "
                    : "bg-zinc-100   " 
                } h-[50px] `}
              >
              {lang === 'en' ? category.value_en : category.value }
              </button>
            ))}
          </div>}
          <br />
          <hr />

          {filter.map((item, index) => (
      <MenuList value={item.value} setFilter={setFilter} fetchProducts={fetchProducts} selected={item.selected}  code={item.code} list={item.children } level={index}  />
          
          ))}
       {/* Custom <hr/> */}
      <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
    
      <Products lang={lang} products={products} animation={animation} />
   
    </section>
  );
};
